import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupBy',
    standalone: false
})
export class GroupByPipe implements PipeTransform {
 
  transform<T>(input: T[], key: keyof T): Record<string, T[]> 
  {
    return input.reduce((result, item) => {
        const keyValue = String(item[key]);
        if (!result[keyValue]) {
          result[keyValue] = [];
        }
        result[keyValue].push(item);
        return result;
      }, {} as Record<string, T[]>);
  }
}





